var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextSelectStart = function SvgTextSelectStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.192 20.5v-1.616h1.616V20.5zm0-15.384V3.5h1.616v1.616zM15.04 20.5v-1.616h1.615V20.5zm0-15.384V3.5h1.615v1.616zM18.884 20.5v-1.616H20.5V20.5zm0-3.846v-1.615H20.5v1.615zm0-3.846v-1.616H20.5v1.616zm0-3.847V7.346H20.5v1.615zm0-3.846V3.5H20.5v1.616zM3.5 20.5V19h2V5h-2V3.5H9V5H7v14h2v1.5z"
  })));
};
export default SvgTextSelectStart;